'use client';
import React, { useEffect, useState, useRef } from 'react';
import './Index.css';
import { Box, Paper, Stack, Typography, SortDirection } from '@mui/material';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import { useStore } from '../../../utils/store';
import CustomPaginationActionsTable from '../../../components/TablePagination';
import StatusRequestData from '../../../Models/StatusRequest';
import { useNavigate } from 'react-router-dom';

import SwitchComponent from '../../../components/SwitchComponent';
import AddButtonComponent from '../../../components/form/AddButtonComponent';
import { useSearch } from '../../../components/searchContext';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import { useAlert } from '../../../components/alertContext';
const Billable: React.FC = () => {
  const { getAdmin } = useStore();
  const { searchQuery } = useSearch();
  const navigate = useNavigate();
  const columns: any[] = [
    { field: 'name', headerName: 'Billable Name' },
    { field: 'price', headerName: 'Price' },
    { field: 'notes', headerName: 'Notes' },
    { field: 'exclusion', headerName: 'Exclusion Notes' },
    {
      field: 'creator',
      headerName: 'User',
    },
    {
      field: 'updated',
      headerName: 'Date Modified',
      valueGetter: (value: any, row: any) => {
        return new Date(value).toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        });
      },
    },
    {
      field: 'status',
      headerName: 'Active',
      disableSort: true,
      renderCell: (value: any, row: any) => (
        <SwitchComponent
          checked={value === '1' ? true : false}
          size="small"
          color={'success'}
          inputProps={{ 'aria-label': 'controlled' }}
          handleInputChange={() => {}}
          name={'rowStatusBillable'}
          value={row.value}
        />
      ),
    },
  ];
  const isInitialLoad = useRef(true);

  const [paginate, setPaginate] = useState<any>({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [rows, setRows] = useState<any>([]);
  const [orderBy, setOrderBy] = useState<any>('created');
  const [order, setOrder] = useState<SortDirection>('desc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  useEffect(() => {
    if (searchQuery || paginate || isInitialLoad.current) {
      fetchData();
    }
    isInitialLoad.current = false;
  }, [searchQuery, paginate]);

  const StatusUpdate = async (dataObj: StatusRequestData) => {
    try {
      const response = await HttpService.patch(
        Constants.apiURL + Constants.billableURL,
        dataObj,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        fetchData();
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const fetchData = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.billableURL + '/list',
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: searchQuery, limit: paginate.limit, offset: paginate.offset }
      );
      if (response.success) {
        setRows(response.data.paginateRecords);
        handleOrderBy('updated');
        setTotalRecords(response.data.total);
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleStatus = (row: any) => {
    let status = '1';
    if (row.status === '1') {
      status = '0';
    }
    if (row.status === '0') {
      status = '1';
    }
    StatusUpdate({ id: row.id, status: status });
  };
  const handlePagination = (paginationData: any) => {
    console.log(paginationData);
    setPaginate(paginationData);
  };

  return (
    <Stack>
      <Box id="main" className="main dashboardmain">
        <section className="section dashboard">
          <div className="containergrid">
            <div className="mt-2">
              <Paper sx={{ width: '100%' }} className="mt-4">
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px',
                    mb: 2,
                  }}
                >
                  <Typography variant="h6"> Billables</Typography>
                  <AddButtonComponent
                    onClick={() => {
                      navigate('/data-management/billable-items/Add');
                      //setDialogOpen(true);
                    }}
                    keyName="quoteaddicon"
                    label="Add New"
                  />
                </Box>
                <CustomPaginationActionsTable
                  rows={rows}
                  columns={columns}
                  totalRecords={totalRecords}
                  handlePagination={handlePagination}
                  order={order}
                  orderBy={orderBy}
                  handleOrderBy={handleOrderBy}
                  handleRowClick={(row) => {
                    navigate('/data-management/billable-items/' + row.id);
                    //console.log(data);
                  }}
                  paginationModel={{
                    page: paginate.offset,
                    pageSize: paginate.limit,
                  }}
                  handleStatus={handleStatus}
                />
              </Paper>
            </div>
          </div>
        </section>
      </Box>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Stack>
  );
};

export default Billable;
